import { createFileRoute } from "@tanstack/react-router";
/**
 * StockOrder Contents Page
 *
 * This page renders a breadcrumb navigation and the StockOrderContentsForm component.
 *
 * The StockOrderId param is required.
 */

import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetStockOrderQueryOptions } from "@/requests/gen/react-query/stock-order";
import StockOrderContentsForm from "./-form";
import { StockOrderCrumbs } from "../../-crumbs";

export const Route = createFileRoute(
  "/_private/_stock-360/stock-order/$stockOrderId/contents/",
)({
  loader: ({ context: { queryClient }, params: { stockOrderId } }) =>
    queryClient.ensureQueryData(getGetStockOrderQueryOptions(stockOrderId)),
  component: StockOrderContentsPage,
});

function StockOrderContentsPage() {
  const { stockOrderId } = Route.useParams();
  const stock_order = useSuspenseQuery(
    suspenseOptions(getGetStockOrderQueryOptions(stockOrderId)),
  );

  return (
    <div>
      <title>{`Stock Order Contents ${stockOrderId} - Legrande Health Portal`}</title>
      <StockOrderCrumbs canEdit={true} />

      {/* StockOrderContents form */}
      <Card>
        <CardHeader>
          <CardTitle>Stock Order Contents</CardTitle>
          <CardDescription>
            Add products to your warehouse order.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {stock_order.data ? (
            <StockOrderContentsForm stock_order={stock_order.data} />
          ) : (
            <div>Loading...</div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
